import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isWidgetDisplayed } from "../../../../../esri/widgets/expandUtils";
import { ConfigContext } from "../../../../../utils/ConfigContext";
import { LayerListIcon } from "../../../../Icons";
import LayerListWidget from "../../../../LayerListWidget/LayerList";
import Section from "../UI/Section/Section";

const LayerList = ({ expanded }) => {
  const view = useSelector((state) => state.mapViewReducer.view);
  const { config } = useContext(ConfigContext);
  const { t } = useTranslation("common");

  const hasWidget = useMemo(() => {
    return isWidgetDisplayed(config, "LayerList");
  }, [config]);

  if (!hasWidget) return null;

  return (
    <Section
      className="onboarding-layer-list"
      expanded={expanded}
      title={t("screen.widget.LayerList.name")}
      information={t("screen.widget.LayerList.information")}
      Icon={LayerListIcon}
      widgetName="LayerList"
    >
      <LayerListWidget
        view={view}
        t={t}
        config={config}
        isWidget={false}
        isSidebar
      />
    </Section>
  );
};

export default LayerList;
